module.exports = __webpack_public_path__ + "media/icons/subway-bd1041ad.svg";